import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'LoaderButton',
  props: {
    size: { default: 'small' },
    themeColor: { default: 'primary' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(`loader loader__spinner loader__spinner--${__props.size} loader__spinner--${__props.themeColor}`)
  }, null, 2))
}
}

})